// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TP57z","labelWrapper":"styles_labelWrapper__oKq1H","label":"styles_label__Zl8u6"};